import React, { useState, useEffect, CSSProperties } from 'react';
import { BrowserRouter as Router, Link, Route, Routes, useParams } from "react-router-dom";

// Bootstrap CSS
import "bootstrap/dist/css/bootstrap.min.css";

import * as constants from '../constants';

import logo from '../assets/cdn_img/logo.png';

export default function Login() {
    const [isSubmitted, setIsSubmitted] = useState(false);

    const loginSubmit = (event) => {
        //Prevent page reload
        event.preventDefault();

        var { emailMobile, password } = document.forms[0];

        console.log("emailMobile, password ", emailMobile, password)
    }

    return (<><br></br>
        <div className='container'>
            <div className='row'>
                <div className='col-sm-7'></div>
                <div className='col-sm-5'>
                    <div className='card'>
                        <div className='card-body'>
                            <form onSubmit={loginSubmit}>
                                <div className='text-center'>
                                    <img className='milesImg' src={logo}></img>
                                    <h2 className=''>Login</h2><hr></hr>
                                </div>

                                <div class="mb-3">
                                    <label for="exampleFormControlInput1" class="form-label">Email/Mobile</label>
                                    <input class="form-control" id="exampleFormControlInput1" name='emailMobile' placeholder="name@example.com"></input>
                                </div>
                                <div class="mb-3">
                                    <label for="exampleFormControlInput1" class="form-label">Password</label>
                                    <input type="password" class="form-control" id="exampleFormControlInput1" name='password' placeholder="Password"></input>
                                </div>
                               
                                <div class="d-grid gap-2">
                                    <button className='btn btn-primary btn-block' type='submit'>Login</button>
                                </div>
                                <p className="small fw-bold mt-2 pt-1 mb-2">Don't have an account? <Link to={"/signup"} className="link-danger">signup</Link></p>
                            </form>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </>)
}